export default "__VITE_ASSET__CXvw3uEY__"